(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming-soon"]) return;
  try {
    
(function () {
  var CLICK_SLOP = 8;   // px of travel still counted as a click, not a drag
  var CLICK_TIME = 500; // ms

  function initSection(section) {
    var stack = section.querySelector('[data-cs-stack]');
    if (!stack) return;

    var cards = Array.prototype.slice.call(stack.querySelectorAll('[data-cs-card]'));
    if (!cards.length) return;

    var css = getComputedStyle(section);
    var maxZoom = parseFloat(css.getPropertyValue('--cs-max-zoom')) || 3;
    var scatter = parseFloat(css.getPropertyValue('--cs-scatter'));
    var tilt = parseFloat(css.getPropertyValue('--cs-tilt'));
    if (isNaN(scatter)) scatter = 40;
    if (isNaN(tilt)) tilt = 12;
    var minZoom = 1;
    var margin = 48; // px of a drawing that must stay on screen

    function rand(min, max) { return min + Math.random() * (max - min); }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
    function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }
    function clampScale(s) { return Math.min(maxZoom, Math.max(minZoom, s)); }

    // The original artwork (first card) stays square-on at the top of the pile;
    // the rest are shuffled and scattered underneath, fresh on every page load.
    var hero = cards[0];
    var buried = cards.slice(1);
    for (var i = buried.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = buried[i]; buried[i] = buried[j]; buried[j] = swap;
    }
    var order = [hero].concat(buried); // index 0 == top of the pile

    var state = new Map();
    cards.forEach(function (card) {
      state.set(card, {
        x: card === hero ? 0 : rand(-scatter, scatter),
        y: card === hero ? 0 : rand(-scatter, scatter),
        r: card === hero ? 0 : rand(-tilt, tilt),
        scale: 1,
        base: null
      });
    });

    function apply(card) {
      var s = state.get(card);
      card.style.transform =
        'translate(' + s.x + 'px,' + s.y + 'px) rotate(' + s.r + 'deg) scale(' + s.scale + ')';
    }

    function applyOrder() {
      order.forEach(function (card, idx) {
        card.style.zIndex = String(order.length - idx);
      });
    }

    // Click anywhere on the pile: the bottom drawing surfaces to the top.
    function cycle() {
      if (order.length < 2) return;
      order.unshift(order.pop());
      applyOrder();
    }

    // Measure a card's untransformed drawing (the image, not its full-bleed box).
    function measure(card) {
      var s = state.get(card);
      var prev = card.style.transform;
      card.style.transform = 'none';
      var img = card.querySelector('img');
      var r = (img || card).getBoundingClientRect();
      card.style.transform = prev;
      s.base = { cx: r.left + r.width / 2, cy: r.top + r.height / 2, w: r.width, h: r.height };
    }

    // Keep a drawing from leaving the viewport (at least `margin` px stays visible).
    function clampTranslate(card) {
      var s = state.get(card);
      if (!s.base) return;
      var halfW = (s.base.w * s.scale) / 2;
      var halfH = (s.base.h * s.scale) / 2;
      var cx = s.base.cx + s.x;
      var cy = s.base.cy + s.y;
      var minCx = margin - halfW, maxCx = window.innerWidth - margin + halfW;
      var minCy = margin - halfH, maxCy = window.innerHeight - margin + halfH;
      cx = Math.min(maxCx, Math.max(minCx, cx));
      cy = Math.min(maxCy, Math.max(minCy, cy));
      s.x = cx - s.base.cx;
      s.y = cy - s.base.cy;
    }

    cards.forEach(function (card) {
      var img = card.querySelector('img');
      if (!img) return;

      var pointers = new Map();
      var gesture = null;
      var travel = 0;
      var downAt = 0;

      function baseline() {
        var s = state.get(card);
        var pts = Array.from(pointers.values());
        gesture = { x: s.x, y: s.y, scale: s.scale };
        if (pts.length >= 2) {
          gesture.dist = dist(pts[0], pts[1]);
          gesture.mid = mid(pts[0], pts[1]);
        } else if (pts.length === 1) {
          gesture.mid = { x: pts[0].x, y: pts[0].y };
        }
      }

      img.addEventListener('pointerdown', function (e) {
        img.setPointerCapture(e.pointerId);
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pointers.size === 1) {
          travel = 0;
          downAt = e.timeStamp;
          measure(card);
        }
        card.classList.add('is-grabbing');
        baseline();
      });

      img.addEventListener('pointermove', function (e) {
        if (!pointers.has(e.pointerId) || !gesture) return;
        var prev = pointers.get(e.pointerId);
        travel += Math.hypot(e.clientX - prev.x, e.clientY - prev.y);
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

        var s = state.get(card);
        var pts = Array.from(pointers.values());
        if (pts.length >= 2) {
          var d = dist(pts[0], pts[1]);
          var m = mid(pts[0], pts[1]);
          s.scale = clampScale(gesture.scale * (d / gesture.dist));
          s.x = gesture.x + (m.x - gesture.mid.x);
          s.y = gesture.y + (m.y - gesture.mid.y);
        } else {
          var p = pts[0];
          s.x = gesture.x + (p.x - gesture.mid.x);
          s.y = gesture.y + (p.y - gesture.mid.y);
        }
        clampTranslate(card);
        apply(card);
      });

      function release(e) {
        if (!pointers.has(e.pointerId)) return;
        pointers.delete(e.pointerId);
        if (pointers.size === 0) {
          gesture = null;
          card.classList.remove('is-grabbing');
          // Barely moved, released quickly? That was a click, not a drag.
          if (travel < CLICK_SLOP && (e.timeStamp - downAt) < CLICK_TIME) cycle();
        } else {
          baseline(); // re-baseline the remaining pointer(s)
        }
      }
      img.addEventListener('pointerup', release);
      img.addEventListener('pointercancel', release);

      img.addEventListener('click', function (e) { e.preventDefault(); });
    });

    function remeasure() {
      cards.forEach(function (card) {
        measure(card);
        clampTranslate(card);
        apply(card);
      });
    }

    applyOrder();
    cards.forEach(apply);

    cards.forEach(function (card) {
      var img = card.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', function () {
        measure(card);
        clampTranslate(card);
        apply(card);
      });
    });
    window.addEventListener('resize', remeasure);
    window.addEventListener('load', remeasure);
    remeasure();
  }

  document.querySelectorAll('[data-section-type="coming-soon"]').forEach(initSection);
})();

  } catch(e) { console.error(e); }
})();
})();
